const PREFIX='earlybird:preferences-draft:';
const AGE=30*24*60*60*1000;
export function validPreferences(value){return !!value && Array.isArray(value.tags) && value.tags.length>=1 && value.tags.length<=20 && value.tags.every(t=>typeof t==='string'&&t.trim().length>0&&t.length<200) && ['fixed','hourly'].every(k=>/^\d+$/.test(value[k])&&Number.isSafeInteger(Number(value[k])));}
export function readPreferenceDraft(uid){
 if(!uid)return null;
 try{const value=JSON.parse(localStorage.getItem(PREFIX+uid));if(value?.version===1&&value.at<=Date.now()&&Date.now()-value.at<AGE&&validPreferences(value))return {tags:value.tags,fixed:value.fixed,hourly:value.hourly};}catch(_){}
 return null;
}
export function savePreferenceDraft(uid,value){
 if(!uid||!validPreferences(value))return false;
 try{localStorage.setItem(PREFIX+uid,JSON.stringify({version:1,at:Date.now(),tags:value.tags,fixed:value.fixed,hourly:value.hourly}));return true;}catch(_){return false;}
}
export function clearPreferenceDraft(uid){try{localStorage.removeItem(PREFIX+uid);}catch(_) {}}
